module.exports = __webpack_public_path__ + "img/cancun-bay-room-4.b3392558.jpg";